var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWindowsHello(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 800 680",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,680.000000) scale(0.100000,-0.100000)",
    fill: "#00a1f1",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1711 6789 c-416 -56 -758 -373 -842 -781 -17 -85 -20 -126 -16 -238 5 -155 22 -236 75 -358 123 -284 367 -491 671 -568 121 -32 333 -35 449 -9 303 69 547 263 683 540 71 145 93 246 93 425 0 86 -5 170 -13 205 -87 393 -384 689 -773 770 -92 20 -238 26 -327 14z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6018 6785 c-317 -52 -594 -250 -733 -525 -76 -151 -105 -275 -105 -454 0 -181 25 -296 98 -441 122 -246 320 -414 594 -506 176 -59 418 -57 605 6 503 168 779 680 647 1200 -49 192 -179 387 -343 517 -209 165 -509 245 -763 203z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400 2966 c-112 -31 -201 -88 -278 -178 -57 -67 -90 -135 -109 -222 -40 -190 46 -383 336 -756 317 -408 670 -733 1122 -1032 654 -433 1270 -660 2049 -755 182 -22 731 -25 915 -5 779 84 1433 321 2094 760 435 288 761 583 1070 967 332 413 433 629 387 828 -66 281 -357 463 -630 392 -143 -37 -227 -103 -369 -288 -303 -393 -660 -740 -1025 -995 -543 -380 -1110 -577 -1792 -623 -530 -35 -1176 99 -1675 348 -531 266 -1036 698 -1473 1260 -153 197 -234 260 -378 298 -69 18 -181 18 -244 1z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWindowsHello);
export default __webpack_public_path__ + "static/media/WindowsHello.11267350983f273f0796c7cb75f0c126.svg";
export { ForwardRef as ReactComponent };